import { ComponentType } from 'react';

import { FinancialAttachmentCard, PayerAddressCard } from '../../../../../../components/cards/financial';
import { AdditionalAttachmentCard } from '../../../../../../components/cards/financial/AttachmentCard';
import PrivacyPolicyCard from '../../../../../../components/cards/financial/PrivacyPolicyCard';
import FinancialPage from '../../../../../../features/FinancialPage';
import { CARD_CATEGORIES } from '../../../../../../shared/cardConfig/constants';
import {
  ATTACHMENT_FIELDS,
  PAYER_ADDRESS_FIELDS
} from '../../../../../../shared/fieldConfig/constants';
import { PAGE_ROUTES } from '../../../../../../utils/constants';

// ----------------- Types -----------------
export interface Field {
  key: string;
  required?: boolean;
}

export interface Card {
  key: string;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  Component: ComponentType<any>;
  hideSameAs?: boolean;
  fields?: Field[];
}

export interface Page {
  route: string;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  Component: ComponentType<any>;
  cards: Card[];
}

// ----------------- Page Template -----------------
const payerPageTemplate: Page = {
  route: PAGE_ROUTES.financial,
  Component: FinancialPage,
  cards: [
    {
      key: CARD_CATEGORIES.payer,
      Component: PayerAddressCard,
      hideSameAs: true,
      fields: [
        { key: PAYER_ADDRESS_FIELDS.address },
        { key: PAYER_ADDRESS_FIELDS.taxNumber1, required: true },
        { key: PAYER_ADDRESS_FIELDS.dnbNumber }
      ]
    },
    // {
    //   key: CARD_CATEGORIES.bankReference,
    //   Component: BankReferenceCard,
    //   fields: [
    //     { key: BANK_REFERENCE_FIELDS.name, required: true },
    //     // { key: BANK_REFERENCE_FIELDS.routingNumber },
    //     { key: BANK_REFERENCE_FIELDS.accountNumber },
    //     { key: BANK_REFERENCE_FIELDS.address },
    //     { key: BANK_REFERENCE_FIELDS.faxNumber },
    //   ],
    // },
    // {
    //   key: CARD_CATEGORIES.bankerContact,
    //   Component: BankerContactCard,
    //   fields: [
    //     { key: BANKER_CONTACT_FIELDS.contactName },
    //     { key: BANKER_CONTACT_FIELDS.email },
    //     { key: BANKER_CONTACT_FIELDS.phoneNumber },
    //   ],
    // },
    {
      key: CARD_CATEGORIES.financialAttachmentCard,
      Component: FinancialAttachmentCard,
      fields: [{ key: ATTACHMENT_FIELDS.financialCardAttachment }]
    },
    {
      key: CARD_CATEGORIES.additionalAttachmentCard,
      Component: AdditionalAttachmentCard,
      fields: [{ key: ATTACHMENT_FIELDS.additionalAttachment }]
    },
    {
      key: CARD_CATEGORIES.privacyPolicy,
      Component: PrivacyPolicyCard
    }
  ]
};

const pages: Page[] = [payerPageTemplate];

export default pages;